import styled from 'styled-components';

import { Button } from '@design-system-coopeuch/web';

export const StyledWrapperCards = styled.div`
  /* TODO: Estilos que se repiten en otro wrapper, ver si se mueven a un style global */
  display: grid;
  grid-row-gap: 16px;
  @media screen and (min-width: 768px) {
    grid-row-gap: 32px;
  }

  && .CardBase--shaded {
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.14);
  }
  && .CardBase_content--no-padding > div {
    padding-right: 16px;
    padding-left: 16px;
    @media screen and (min-width: 768px) {
      padding-right: 32px;
      padding-left: 32px;
    }
  }
  & .CardBase > header {
    padding: 16px 16px;
    @media screen and (min-width: 768px) {
      padding: 20px 32px;
      align-items: center;
    }
  }
  & .CardBase--titles {
    row-gap: 4px;
  }
  & .CardBase--titles > h2 {
    font-size: 18px;
    line-height: 24px;
    font-weight: 500;
    @media screen and (min-width: 768px) {
      font-size: 24px;
      line-height: 30px;
    }
  }
  & .CardBase--titles > h4 {
    font-size: 14px;
    line-height: 20px;
  }
  & .CardBase p {
    font-size: 14px;
  }
  & .CardBase .title-content {
    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
  }
  & .CardBase .subtitle-content {
    font-size: 14px;
    line-height: 20px;
  }
  & .CardBase .text-content {
    font-size: 14px;
    line-height: 22px;
  }
`;

export const StyledButton = styled(Button)`
  justify-content: start;
  padding: 0px;
  & > span {
    font-size: 16px;
  }
  & i {
    font-size: 18px !important;
  }
`;

export const StyledWrapperSms = styled.section`
  & .CardBase header {
    padding: 16px;
    background-color: #dff3fd;
    & h2 {
      font-size: 16px;
      font-weight: 400;
    }
  }
  & .rounded-pill {
    font-size: 20px;
    font-weight: 400;
    @media screen and (min-width: 768px) {
      max-width: 250px;
    }
  }
  /* & .InputCodeSMS {
    @media screen and (min-width: 768px) {
      max-width: 400px;
    }
  } */
`;

export const StyledGridFees = styled.div`
  width: 100%;
  display: grid;
  grid-gap: 16px;
  justify-content: center;
  & input[type="text"] {
    text-align: center;
  }
  & > div:nth-child(3) {
    margin-bottom: 12px;
  }
  @media screen and (min-width: 768px) {
    grid-template-columns: 20% 4% 23% auto;
    align-items: center;
    & > div:nth-child(1) {
      /* margin-top: 12px; */
    }
    & > div:nth-child(3) {
      margin-bottom: 22px;
    }
    & > div:nth-child(4) {
      display: flex;
      justify-content: flex-end;
    }
  }
`;

export const StyledContractContainer = styled.section.attrs(() => ({
  className: '',
}))`
  display: flex;
  flex-direction: column;
  padding: 20px 32px;
  & article {
    flex: 1 1 auto;
    & h6 {
      margin-bottom: 4px;
    }
    & p {
      font-size: 14px;
      line-height: 20px;
      color: #383838;
    }
    & li {
      font-size: 14px;
      line-height: 20px;
      color: #383838;
    }
    & ul, ol {
      margin-top: 4px;
      display: grid;
      grid-row-gap: 8px;
      padding-left: 16px;
    }
    & ul {
      list-style: none;
    }
    & ul li::before {
      content: '\\2022';
      /* color: #007dbc; */
      color: #383838;
      font-weight: bold;
      display: inline-block;
      width: 1em;
      margin-left: -1rem;
    }
  }
  & div {
    flex: 0 1 auto;
    display: flex;
    justify-content: center;
  }
  @media screen and (min-width: 768px) {
    flex-direction: row;
    & > div button {
      align-items: flex-start !important;
    }
  }
`;
